import { Box, Button, Grid, Stack, Typography } from '@mui/material';
import React, { useState } from 'react';
import Background from 'v2/components/Background/Background';
import Loader from 'v2/components/Loader/Loader';
import useSnackbarContext from 'v2/components/Snackbar/useSnackbarContext';
import useCurrentTenant from 'v2/hooks/onboarding/useCurrentTenant/useCurrentTenant';
import ConnectCognitoWizard from './ConnectCognitoWizard';
import ConnectEntraWizard from './ConnectEntraWizard';
import InvalidOTR from './InvalidOTR';
import LicensePortalWizard from './LicensePortalWizard';

const PageLayout: React.FC<React.PropsWithChildren> = ({ children }) => (
  <Background>
    <Grid container>
      <Box
        sx={{
          minHeight: '100vh',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          margin: '0 auto'
        }}
      >
        {children}
      </Box>
    </Grid>
  </Background>
);

const LicensePortalPage: React.FC<React.PropsWithChildren> = () => {
  const { showSnackbar } = useSnackbarContext();
  const handleFetchError = (errorMessage: string) => showSnackbar(errorMessage, { severity: 'error' });
  const { currentTenant } = useCurrentTenant({
    handleFetchError
  });

  const [isProcessStarted, setIsProcessStarted] = useState(false);

  const handleWelcomePageButtonOnClick = () => {
    setIsProcessStarted(true);
  };

  const getCurrentStep = () => {
    if (!currentTenant) {
      return 'Loading';
    }

    if (currentTenant.onboardingStep === 'AcceptLegalDocuments' && !isProcessStarted) return 'NotStarted';

    return currentTenant.onboardingStep;
  };

  const currentStep = getCurrentStep();

  const renderContent = () => {
    switch (currentStep) {
      case 'Loading':
        return <Loader />;
      case 'NotStarted':
        return (
          <Stack gap={5}>
            <Stack flexDirection="row" alignItems="center" gap={1}>
              <Typography variant="h3" color="textPrimary">
                Welcome to
              </Typography>
              <Typography variant="h3" color="primary">
                ATLAS
              </Typography>
            </Stack>
            <Button
              id="start-setup-button"
              variant="contained"
              color="primary"
              onClick={() => handleWelcomePageButtonOnClick()}
              sx={(theme) => ({
                width: 148,
                padding: '8px 22px',
                alignSelf: 'center',
                boxShadow: theme.shadows[2]
              })}
            >
              Start Setup
            </Button>
          </Stack>
        );
      case 'AcceptLegalDocuments':
        return <LicensePortalWizard initialStep={0} />;
      case 'ChooseProvider':
        return <LicensePortalWizard initialStep={2} />;
      case 'ConnectEntra':
        return <ConnectEntraWizard initialStep={0} />;
      case 'LinkEntra':
        return <ConnectEntraWizard initialStep={1} />;
      case 'TenantReadyEntra':
        return <ConnectEntraWizard initialStep={3} />;
      case 'CreateAccount':
        return <ConnectCognitoWizard initialStep={0} />;
      case 'VerifyAccount':
        return <ConnectCognitoWizard initialStep={1} />;
      case 'TenantReadyCognito':
        return <ConnectCognitoWizard initialStep={2} />;
      default:
        return <InvalidOTR />;
    }
  };

  return <PageLayout>{renderContent()}</PageLayout>;
};
export default LicensePortalPage;
